import React from 'react';
import { connect } from 'react-redux';
import { datasetEndpoint } from '@/constants/urls';
import { findMatch } from '@/utils/resultsHelper';
import { downloadDatasetConditionAttachment } from '../actions';

const UserDefinedAttachmentLink = ({
  children,
  code,
  datasetCondition,
  downloadAttachment,
  isDownloading,
}) => {
  const isNew = !datasetCondition.id;

  return (
    <>
      {isNew && <span>{children}</span>}
      {!isNew && (
        <a
          href={`/api${datasetEndpoint(code)}/conditions/${datasetCondition.id}/attachment`}
          onClick={(e) => {
            e.preventDefault();
            if (isDownloading || !datasetCondition.id) {
              return;
            }
            downloadAttachment();
          }}
        >
          {children}
        </a>
      )}
    </>
  );
};

const mapStateToProps = (
  {
    datasetConditions: {
      attachments: { downloadsInProgress },
    },
  },
  { datasetCondition },
) => ({
  isDownloading: !!findMatch(downloadsInProgress, datasetCondition.id, 'id'),
});

const mapDispatchToProps = (dispatch, { code, datasetCondition }) => ({
  downloadAttachment: () => dispatch(downloadDatasetConditionAttachment(code, datasetCondition)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDefinedAttachmentLink);
